import { boolean, defineAction, number, object, string } from '~/prix'
import llmChatUpdateAction from './llmChatUpdate.action.json' with { type: 'json' }

const llmChatUpdateDefinition = defineAction({
  ...llmChatUpdateAction,

  // input: z.object({
  //   id: z.number(),
  //   title: z.string().nullish(),
  //   isFixed: z.boolean().nullish(),
  //   archivedAt: dateOrIsoString().nullish(),
  // }),
  // output: z.object({}),
  input: object({
    id: number(),
    title: string().isOptional(),
    isFixed: boolean().isOptional(),
    archivedAt: string().isOptional(),
  }),
  output: object({}),
})

export default llmChatUpdateDefinition
